import { ActivatedRoute } from '@angular/router';
import { Subscription } from '../../_models/subscription';

import { StudentService } from '../../_services/student.service';

import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../_services/auth.service';

@Component({
  selector: 'app-quiz-tab-done',
  templateUrl: './quiz-tab-done.component.html',
  styleUrls: ['./quiz-tab-done.component.css']
})
export class QuizTabDoneComponent implements OnInit {
  guardian:any={}
  subscriptionId=0
  doneQuizEnvelops=undefined
  hasEnrollments=false
  isPremium=false
  studentUserId:0
  server_enrolment_id=0
  quiz_mode_name=""
  server_student_user_id=0
  maxOpenSubjectQuiz=0
  maxOpenQuizNoAlert=0
  allQuizCount=0
  showQuizItems=false
  loading=false
  learner:any={}
  giftinfo:any={}
  subscription = new Subscription()
  loadingEnvelops=false
  dtOptions: DataTables.Settings = {};
  maskedGift=undefined
  constructor(
    public authService:AuthService,
    private studentService:StudentService,
    private activatedRoute:ActivatedRoute) { }

  ngOnInit(): void {
    this.loading=true

    this.dtOptions = {pagingType: 'full_numbers'}
    this.activatedRoute.params.subscribe(
      myParams => {
        this.server_student_user_id = myParams['server_student_user_id']
        this.quiz_mode_name =myParams['quiz_mode_name']
        this.studentService.getGiftingInformation(this.server_student_user_id).subscribe(
          giftinfo=>{this.giftinfo=giftinfo}
        )
        this.studentService.minStudentData.subscribe(
          learner=>{
            this.loading=false
            this.learner=learner
            this.subscription=learner['subscription_object']
          }
        )
        this.loadingEnvelops=true

      })
      this.loadEnvelops()
      this.initGifting()
    }
    loadEnvelops(){
      this.studentService.getDoneQuizByStudentUserId(this.server_student_user_id, this.quiz_mode_name).subscribe(
        data => {
          if (data) {
             this.maxOpenSubjectQuiz = data['maxOpenSubjectQuiz']
             this.maxOpenQuizNoAlert = data['maxOpenQuizNoAlert']
             this.doneQuizEnvelops = data['doneQuizEnvelops']
             this.loadingEnvelops=false
             this.subscription = data['subscription_object']
             this.server_enrolment_id = data['currentEnrolment'] ? data['currentEnrolment'].server_enrolment_id:0
             if (data['subscription_object'] != null) {
               this.isPremium = this.subscription['is_premium_subscription_type']==1
               this.subscriptionId = this.subscription['server_subscription_id']
             }
           }

         }
       )
    }
    initGifting(){
      this.studentService.getGiftingInformation(this.server_student_user_id).subscribe(
        myMaskedGift=>{
          this.maskedGift=myMaskedGift
        }
      )
    }
}
